import axios from 'axios';
import Auth from './auth';
import { API_ROOT } from './apiConfig';

export default class SettingsDataAccess {
    options() {
        return { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${new Auth().getToken()}` }, timeout: 30000 };
    }
    getAccountSettings(account) { return this.getAccountSettingsBySettingsName('CostPerCase', account); }
    getAccountSettingsBySettingsName(settingsName, account) {
        return axios.post(`${API_ROOT}/api/v1/Schedule/GetAccountSettings`, {
            Account: account || new Auth().getActiveAccount(), SettingName: settingsName
        }, this.options());
    }
    setAccountSettings(setting) {
        return axios.post(`${API_ROOT}/api/v1/Schedule/SaveAccountSettings`, {
            Id: setting.Id, Account: setting.Account, SettingName: 'CostPerCase',
            SettingValue: String(setting.SettingValue), IsDeleted: false,
            ExpectedVersion: setting.ExpectedVersion, ChangeId: setting.ChangeId
        }, this.options());
    }
    saveIndividualFaxingSettings(id, enabled, expectedVersion, changeId, account) {
        return axios.post(`${API_ROOT}/api/v1/Schedule/SaveAccountSettings`, {
            Id: id, Account: account, SettingName: 'FaxByAddress', SettingValue: enabled ? '1' : '0',
            IsDeleted: false, ExpectedVersion: expectedVersion, ChangeId: changeId
        }, this.options());
    }
}



// WEBPACK FOOTER //
// ./src/services/settingsDataAccess.js